export default __webpack_public_path__ + "static/media/JennyLovelace.35cadc53.png";